import * as R from 'ramda';
import { createSelector } from 'reselect';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  makeSelectPagination,
  makeSelectListLoading,
  makeSelectReportStatus,
} = getReportSelectors('averageFuelPrice');

const store = ({ averageFuelPrice }) => averageFuelPrice;

const makeSelectActiveTab = createSelector(
  store,
  ({ activeTab }) => activeTab,
);

const makeSelectItemList = createSelector(
  store,
  ({ activeTab, ...state }) => R.pathOr([], [activeTab, 'itemList'], state),
);

const makeSelectTotalCount = createSelector(
  store,
  ({ activeTab, ...state }) => R.pathOr(0, [activeTab, 'totalCount'], state),
);

const makeSelectTitleSortValues = createSelector(
  store,
  ({ activeTab, ...state }) => R.pathOr([], [activeTab, 'titleSortValues'], state),
);

const makeSelectTableTitleFilters = createSelector(
  store,
  ({ activeTab, ...state }) => R.pathOr([], [activeTab, 'tableTitleFilters'], state),
);

export {
  makeSelectItemList,
  makeSelectActiveTab,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectTableTitleFilters,
};
